import { useCallStore } from "~/stores/useCallStore";
import { useLiveStore } from "~/stores/useLiveStore";
import { isCallPhaseActive, isLivePhaseActive } from "~/utils/callPhase";

/**
 * 通話中（発信中・着信中・通話接続中）または配信視聴中かどうかを返す。
 * ポーリング停止・Toast表示抑制の判定に使用する。
 * 判定ロジック本体は utils/callPhase の純粋関数を共有する。
 */
export const useIsOnCall = (): boolean => {
  const callPhase = useCallStore((s) => s.phase);
  const livePhase = useLiveStore((s) => s.phase);

  return isCallPhaseActive(callPhase) || isLivePhaseActive(livePhase);
};
